
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ProgramsPage = lazy(() => import('../pages/programs/page'));
const HowItWorksPage = lazy(() => import('../pages/how-it-works/page'));
const IntakeFormPage = lazy(() => import('../pages/intake-form/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const BookConsultation = lazy(() => import('../pages/book-consultation/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/programs',
    element: <ProgramsPage />,
  },
  {
    path: '/how-it-works',
    element: <HowItWorksPage />,
  },
  {
    path: '/intake-form',
    element: <IntakeFormPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/book-consultation',
    element: <BookConsultation />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
